import { tryParseJSON } from '../../utilities';
import type { ItemType, FormType, ApiPayload } from './useCampaignActions';

const parseStrategy = (strategy: Record<string, any> | undefined) => {
  if (!strategy) return {};

  return { ...strategy };
};
export const convertItemToForm = (item: Partial<ItemType>): FormType => {
  return {
    ...item,
    dialer_calling_schedule: item.dialer_calling_schedule
      ? JSON.stringify(item.dialer_calling_schedule)
      : '',
    dialer_retry_backoff_minutes:
      item.dialer_retry_backoff_minutes?.join(',') || '',
    ...parseStrategy(item.strategy),
  };
};

export const convertFormToPayload = (
  {
    export_fields,
    monitoring_fields,
    max_slot_capacity,
    max_concurrent_calls,
    dialer_calling_schedule,
    time_slot_duration_minutes,
    dialer_retry_backoff_minutes,
    ...form
  }: FormType,
  initialValues?: ItemType
): ApiPayload => {
  const parsedDialerCallingSchedule = tryParseJSON(dialer_calling_schedule);

  return {
    ...form,
    name: form.name || '',
    dialer_retry_backoff_minutes: dialer_retry_backoff_minutes
      ? dialer_retry_backoff_minutes
          .split(',')
          .map(item => parseInt(item))
          .filter(Boolean)
      : [],
    dialer_calling_schedule:
      typeof parsedDialerCallingSchedule === 'object'
        ? parsedDialerCallingSchedule
        : null,
    strategy: {
      ...initialValues?.strategy,
      export_fields,
      monitoring_fields,
      max_slot_capacity,
      max_concurrent_calls,
      time_slot_duration_minutes,
    },
  };
};
